export default "__VITE_ASSET__BBPBI2ra__"